export default {"src":"/_next/static/media/homepage-fb-footer-icon-desktop.c7c77bcb.svg","height":35,"width":16,"blurWidth":0,"blurHeight":0};